var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v4h2c1.1 0 2 1 2 2v10a2 2 0 0 1-2 2h-2v4a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-4H4a2 2 0 0 1-2-2V12c0-1.1.9-2 2-2h2V6Zm-2 6v10h2v-4.5c0-.8.7-1.5 1.5-1.5h17c.8 0 1.5.7 1.5 1.5V22h2V12H4Zm20-2H8V6h16v4ZM8 18v10h16V18H8Zm2 3c0-.6.4-1 1-1h10a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1Zm0 4c0-.6.4-1 1-1h10a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/print.6c077789d0420fcc92baf8b258425853.svg";